<template>
    <div class="upload-wrapper">
        <div v-if="plantaAssinadaUrl && !deveForcarVisualizacaoImagemStatusAssinaturaSuape">
            <div class="pdf-viewer-container">
                <div class="pdf-viewer">
                    <iframe
                        :src="srcVisualizacaoPlantaAssinada"
                        class="pdf-iframe"
                        frameborder="0"
                    ></iframe>
                </div>
            </div>
            <div class="botoes-acoes-container">
                <b-button
                    v-if="editavel"
                    @click="substituirPlantaAssinada"
                    class="btn-acao btn-custom-azul"
                >
                    Substituir Planta Falada
                </b-button>
            </div>
        </div>

        <div v-else>
        <div v-if="etapaAtiva !== 3 && podeGerarPdfParaAssinatura" class="d-flex justify-content-center align-items-center mb-4 steps-container">
            <div class="step-item" :class="{ active: etapaAtiva === 1, completed: etapaAtiva > 1 }">
                <i v-if="etapaAtiva > 1" class="fa fa-check-circle step-icon-green"></i>
                <span v-else class="step-dot"></span>
                <span class="step-label">Upload de Planta</span>
            </div>
            <div class="step-line" :class="{ completed: etapaAtiva >= 2 }"></div>
            <div class="step-item" :class="{ active: etapaAtiva === 2, completed: etapaAtiva > 2 }">
                <i v-if="etapaAtiva > 2" class="fa fa-check-circle step-icon-green"></i>
                <span v-else class="step-dot"></span>
                <span class="step-label">Gerar PDF</span>
            </div>
            <div class="step-line" :class="{ completed: etapaAtiva >= 3 }"></div>
            <div class="step-item" :class="{ active: etapaAtiva === 3, completed: etapaAtiva > 3 }">
                <i v-if="etapaAtiva > 3" class="fa fa-check-circle step-icon-green"></i>
                <span v-else class="step-dot"></span>
                <span class="step-label">Anexar Assinado</span>
            </div>
        </div>

        <div v-if="!temArquivo">
            <div class="planta-falada-container mb-3">
                <div class="pf-header-section">
                    <div class="pf-logo-area pf-logo-left">
                        <img :src="logoSuape" alt="Logo SUAPE" class="img-fluid pf-logo-img" />
                    </div>
                    <div class="pf-title-center">
                        PLANTA FALADA - BOLETIM DE MEDIÇÃO
                    </div>
                    <div class="pf-logo-area pf-logo-right">
                        <img v-if="dadosPlantaFalada.logoFornecedorUrl" :src="dadosPlantaFalada.logoFornecedorUrl" alt="Logo Contratada" class="img-fluid pf-logo-img" />
                        <div v-else class="pf-box-placeholder">
                            Logomarca da empresa<br>(consórcio) contratada
                        </div>
                    </div>
                </div>
                <div class="pf-data-table">
                    <div class="pf-table-row">
                        <div class="pf-cell pf-left-col">
                            <span class="pf-label">CONTRATO:</span>
                            <span class="pf-value">{{ dadosPlantaFalada.numeroContrato }}</span>
                        </div>
                        <div class="pf-cell pf-right-col">
                            <span class="pf-label">MEDIÇÃO:</span>
                            <span class="pf-value">{{ dadosPlantaFalada.medicao }}</span>
                        </div>
                    </div>
                    <div class="pf-table-row">
                        <div class="pf-cell pf-left-col">
                            <span class="pf-label">CONTRATADA:</span>
                            <span class="pf-value">{{ dadosPlantaFalada.contratada }}</span>
                        </div>
                        <div class="pf-cell pf-right-col">
                            <span class="pf-label">PERÍODO:</span>
                            <span class="pf-value">{{ dadosPlantaFalada.periodo }}</span>
                        </div>
                    </div>
                    <div class="pf-table-row">
                        <div class="pf-cell pf-full-col">
                            <span class="pf-label">OBJETO:</span>
                            <span class="pf-value pf-object-text">{{ dadosPlantaFalada.objeto }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="upload-card">
                <div class="d-flex flex-column flex-grow-1 align-items-center w-100">
                    <div class="mt-5">
                        <i class="fa fa-upload fa-4x text-muted opacity-50"></i>
                    </div>
                    <div class="mt-3 text-center">
                        <p class="text-muted mb-2">A imagem deve conter as cores de execução e a legenda técnica.</p>
                        <p class="text-muted mb-0">Formatos aceitos: JPG, JPEG e PNG</p>
                    </div>
                </div>
                <div class="d-flex flex-grow-1 justify-content-center align-items-center w-100 mt-4 mb-5">
                    <div class="d-flex justify-content-center align-items-center w-100">
                        <b-form-file
                            ref="fileInput"
                            v-model="file"
                            placeholder="Clique ou arraste o arquivo para selecionar"
                            browse-text="Selecionar arquivo"
                            drop-placeholder="Solte o arquivo aqui..."
                            accept=".jpg,.jpeg,.png,.pdf"
                            :disabled="!editavel"
                            @input="handleFileChange"
                            style="min-width: 400px; max-width: 600px;"
                        />
                        <b-button
                            v-show="arquivoPendente"
                            variant="light"
                            v-b-tooltip.hover
                            title="Limpar arquivo selecionado"
                            @click="cancelarUpload"
                        >
                            <i class="fa fa-times fa-thin text-danger font-weight-bold"></i>
                        </b-button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="temArquivo && etapaAtiva === 2" class="etapa-geracao-pdf-container">
            <div v-if="carregandoPdf" class="loading-overlay">
                <div class="spinner-container">
                    <i class="fa fa-spinner fa-spin fa-3x text-primary"></i>
                    <p class="mt-3 text-primary font-weight-bold">Gerando PDF...</p>
                </div>
            </div>

            <div v-if="deveExibirImagemComCabecalho || (semPlantaFaladaAnexada && !pdfUrl)" class="planta-falada-container">
                <!-- Cabeçalho com logos e tí­tulo -->
                <div class="pf-header-section">
                    <div class="pf-logo-area pf-logo-left">
                        <img :src="logoSuape" alt="Logo SUAPE" class="img-fluid pf-logo-img" />
                    </div>
                    <div class="pf-title-center">
                        PLANTA FALADA - BOLETIM DE MEDIÇÃO
                    </div>
                    <div class="pf-logo-area pf-logo-right">
                        <img v-if="dadosPlantaFalada.logoFornecedorUrl" :src="dadosPlantaFalada.logoFornecedorUrl" alt="Logo Contratada" class="img-fluid pf-logo-img" />
                        <div v-else class="pf-box-placeholder">
                            Logomarca da empresa<br>(consórcio) contratada
                        </div>
                    </div>
                </div>

                <!-- Tabela de dados contratuais -->
                <div class="pf-data-table">
                    <div class="pf-table-row">
                        <div class="pf-cell pf-left-col">
                            <span class="pf-label">CONTRATO:</span>
                            <span class="pf-value">{{ dadosPlantaFalada.numeroContrato }}</span>
                        </div>
                        <div class="pf-cell pf-right-col">
                            <span class="pf-label">MEDIÇÃO:</span>
                            <span class="pf-value">{{ dadosPlantaFalada.medicao }}</span>
                        </div>
                    </div>

                    <div class="pf-table-row">
                        <div class="pf-cell pf-left-col">
                            <span class="pf-label">CONTRATADA:</span>
                            <span class="pf-value">{{ dadosPlantaFalada.contratada }}</span>
                        </div>
                        <div class="pf-cell pf-right-col">
                            <span class="pf-label">PERÍODO:</span>
                            <span class="pf-value">{{ dadosPlantaFalada.periodo }}</span>
                        </div>
                    </div>

                    <div class="pf-table-row">
                        <div class="pf-cell pf-full-col">
                            <span class="pf-label">OBJETO:</span>
                            <span class="pf-value pf-object-text">{{ dadosPlantaFalada.objeto }}</span>
                        </div>
                    </div>
                </div>

                <div v-if="semPlantaFaladaAnexada && !pdfUrl" class="sem-planta-falada-notice mt-3">
                    <i class="fa fa-info-circle fa-2x mr-3 text-info"></i>
                    <span>Este boletim não possui Planta Falada anexada.</span>
                </div>

                <template v-else>
                    <div v-if="imagemPlantaFaladaUrl" class="pf-imagem-container">
                        <img :src="imagemPlantaFaladaUrl" alt="Planta Falada" class="pf-imagem" />
                    </div>
                    <div v-else class="pf-imagem-placeholder">
                        <div class="pf-imagem-area">
                            <i class="fa fa-image fa-4x text-muted mb-3"></i>
                            <p class="text-muted mb-0">Imagem da Planta Falada</p>
                        </div>
                    </div>
                </template>
            </div>

            <!-- Visualizador de PDF quando upload foi feito manualmente -->
            <div v-else>
                <div class="pdf-viewer-container">
                    <div class="pdf-viewer">
                        <div v-if="carregandoPdf" class="d-flex align-items-center justify-content-center h-100">
                            <b-spinner label="Carregando PDF..."></b-spinner>
                        </div>
                        <iframe
                            v-else-if="pdfUrl"
                            :src="srcVisualizacaoPdf"
                            class="pdf-iframe"
                            frameborder="0"
                        ></iframe>
                        <p v-else class="text-center text-muted">PDF exibido aqui</p>
                    </div>
                </div>
            </div>

        </div>

        <div v-if="etapaAtiva !== 3" class="mt-3 mb-3 d-flex justify-content-start align-items-center flex-wrap">
            <b-button
                variant="warning"
                class="mr-2 mb-2"
                @click="$emit('voltar')"
            >
                <svg class="mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.75 8.75L0.75 4.75M0.75 4.75L4.75 0.75M0.75 4.75H8.75C9.81087 4.75 10.8283 5.17143 11.5784 5.92157C12.3286 6.67172 12.75 7.68913 12.75 8.75C12.75 9.81087 12.3286 10.8283 11.5784 11.5784C10.8283 12.3286 9.81087 12.75 8.75 12.75H6.75" stroke="#2D3439" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Voltar
            </b-button>

            <template v-if="temArquivo && etapaAtiva === 2">
                <b-button
                    v-if="editavel && podeTrocarImagem"
                    variant="outline-danger"
                    @click="trocarImagem"
                    class="btn-acao mr-2 mb-2"
                >
                    <i class="fa fa-trash mr-2"></i>
                    Trocar Imagem
                </b-button>
                <b-button
                    @click="acaoBotaoFluxoAssinatura"
                    v-if="!pdfProntoParaAssinatura && podeGerarPdfParaAssinatura"
                    :disabled="carregandoPdf"
                    class="btn-acao btn-custom-azul mr-2 mb-2"
                >
                    <span v-if="carregandoPdf">
                        <i class="fa fa-spinner fa-spin mr-2"></i>Gerando...
                    </span>
                    <span v-else>
                        <i class="fa fa-print mr-2"></i>
                        {{ textoBotaoFluxoAssinatura }}
                    </span>
                </b-button>
                <b-button
                    v-if="pdfProntoParaAssinatura"
                    @click="baixarPdfAssinatura"
                    class="btn-acao btn-custom-azul mr-2 mb-2"
                >
                    <i class="fa fa-download mr-2"></i>
                    Baixar PDF
                </b-button>
                <b-button
                    @click="proximaEtapa"
                    v-if="pdfProntoParaAssinatura"
                    :disabled="!editavel || carregandoPdf"
                    class="btn-acao btn-green-custom mb-2"
                >
                    <i class="fa fa-check mr-2"></i>
                    Próxima Etapa
                </b-button>
            </template>
        </div>

        <div v-if="etapaAtiva === 3" class="anexar-assinado-container">
            <div class="planta-falada-container mb-3">
                <div class="pf-header-section">
                    <div class="pf-logo-area pf-logo-left">
                        <img :src="logoSuape" alt="Logo SUAPE" class="img-fluid pf-logo-img" />
                    </div>
                    <div class="pf-title-center">
                        PLANTA FALADA - BOLETIM DE MEDIÇÃO
                    </div>
                    <div class="pf-logo-area pf-logo-right">
                        <img v-if="dadosPlantaFalada.logoFornecedorUrl" :src="dadosPlantaFalada.logoFornecedorUrl" alt="Logo Contratada" class="img-fluid pf-logo-img" />
                        <div v-else class="pf-box-placeholder">
                            Logomarca da empresa<br>(consórcio) contratada
                        </div>
                    </div>
                </div>
                <div class="pf-data-table">
                    <div class="pf-table-row">
                        <div class="pf-cell pf-left-col">
                            <span class="pf-label">CONTRATO:</span>
                            <span class="pf-value">{{ dadosPlantaFalada.numeroContrato }}</span>
                        </div>
                        <div class="pf-cell pf-right-col">
                            <span class="pf-label">MEDIÇÃO:</span>
                            <span class="pf-value">{{ dadosPlantaFalada.medicao }}</span>
                        </div>
                    </div>
                    <div class="pf-table-row">
                        <div class="pf-cell pf-left-col">
                            <span class="pf-label">CONTRATADA:</span>
                            <span class="pf-value">{{ dadosPlantaFalada.contratada }}</span>
                        </div>
                        <div class="pf-cell pf-right-col">
                            <span class="pf-label">PERÍODO:</span>
                            <span class="pf-value">{{ dadosPlantaFalada.periodo }}</span>
                        </div>
                    </div>
                    <div class="pf-table-row">
                        <div class="pf-cell pf-full-col">
                            <span class="pf-label">OBJETO:</span>
                            <span class="pf-value pf-object-text">{{ dadosPlantaFalada.objeto }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="upload-card">
                <div class="upload-wrapper">
                    <div class="d-flex justify-content-center align-items-center mb-4 steps-container-upload">
                        <div class="step-item-upload step-blue-upload">
                            <span class="step-dot-blue-upload completed"></span>
                            <span class="step-label-blue-upload">Pré-visualização do PDF</span>
                        </div>
                        <div class="step-line-upload completed"></div>
                        <div class="step-item-upload active">
                            <span class="step-dot-upload"></span>
                            <span class="step-label-grey-upload">Anexar PDF Assinado</span>
                        </div>
                    </div>
                </div>

                <div class="alert-success-custom mb-4">
                    <div class="d-flex align-items-center justify-content-center text-center p-3">
                        <i class="fa fa-check-circle-o fa-2x mr-3 text-success"></i>
                        <span class="text-instruction font-weight-500">
                            Agora que você imprimiu e assinou (fisicamente ou digitalmente) o documento em PDF, <br>
                            faça o upload do arquivo assinado.
                        </span>
                    </div>
                </div>

                <div v-if="!nomeArquivoAssinadoExistente" class="d-flex flex-column flex-grow-1 align-items-center w-100">
                    <div class="mt-5">
                        <i class="fa fa-upload fa-4x text-muted opacity-50"></i>
                    </div>

                    <div class="mt-5">
                        <p class="text-muted">
                            <i class="fa fa-file-pdf-o mr-1"></i>
                            Apenas arquivos em formato PDF são permitidos
                        </p>
                    </div>
                </div>

                <div class="d-flex flex-grow-1 justify-content-center align-items-center w-100 mb-5">
                    <div class="d-flex justify-content-center align-items-center w-100">
                        <b-form-file
                            ref="fileInputAssinado"
                            v-model="fileAssinado"
                            :placeholder="nomeArquivoAssinadoExistente || 'Clique ou arraste o arquivo para selecionar'"
                            :browse-text="nomeArquivoAssinadoExistente ? 'Substituir Arquivo' : 'Selecionar Arquivo'"
                            drop-placeholder="Solte o arquivo PDF aqui..."
                            accept=".pdf,application/pdf"
                            :disabled="!editavel || carregandoUpload"
                            @input="handleFileChangeAssinado"
                            style="min-width: 400px; max-width: 600px;"
                        />

                        <b-button
                            v-show="fileAssinado"
                            variant="light"
                            v-b-tooltip.hover
                            title="Limpar arquivo selecionado"
                            @click="limparArquivoAssinado"
                        >
                            <i class="fa fa-times fa-thin text-danger font-weight-bold"></i>
                        </b-button>

                        <b-button
                            class="ml-3 btn-custom-azul"
                            @click.stop="enviarArquivoAssinadoSelecionado"
                            :disabled="desabilitarBtnEnviarAssinado"
                            style="min-width: 130px;"
                        >
                            <i class="fa fa-upload mr-2"></i>
                            Enviar Arquivo Assinado
                        </b-button>

                    </div>
                </div>

            </div>

            <div class="mt-3 mb-3 d-flex justify-content-start align-items-center">
                <b-button
                    variant="warning"
                    class="mr-2"
                    @click="voltarEtapa"
                >
                    <svg class="mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.75 8.75L0.75 4.75M0.75 4.75L4.75 0.75M0.75 4.75H8.75C9.81087 4.75 10.8283 5.17143 11.5784 5.92157C12.3286 6.67172 12.75 7.68913 12.75 8.75C12.75 9.81087 12.3286 10.8283 11.5784 11.5784C10.8283 12.3286 9.81087 12.75 8.75 12.75H6.75" stroke="#2D3439" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Voltar
                </b-button>
            </div>
        </div>

        <b-modal
            id="modalConfirmarUpload"
            v-model="mostrarModalConfirmacao"
            title="Confirmar Upload"
            @ok="confirmarUpload"
            @cancel="cancelarUpload"
            @hide="limparPreview"
            ok-title="Confirmar"
            cancel-title="Cancelar"
            size="lg"
        >
            <p class="mb-3">Confirma o upload do arquivo?</p>

            <div v-if="previewUrl" class="preview-container">
                <img
                    v-if="ehImagem"
                    :src="previewUrl"
                    alt="Preview"
                    class="preview-imagem"
                />
                <iframe
                    v-else-if="ehPdf"
                    :src="previewUrl"
                    class="preview-pdf"
                    frameborder="0"
                ></iframe>
            </div>
        </b-modal>
        </div>
    </div>
</template>

<script>
import BoletimMedicaoServicos from '../../BoletimMedicaoServicos.js'
import { statusBoletimMedicaoEnum } from '../../BoletimMedicao.js'
import { tiposAnexoEnum } from '../../tiposAnexo.js'

export default {
    props: {
        contrato: {
            type: Object,
            default: null
        },
        boletimMedicao: {
            type: Object,
            default: null
        },
        editavel: {
            type: Boolean,
            default: false
        },
        podeTrocarImagem: {
            type: Boolean,
            default: true
        },
        fornecedorLogoUrl: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            file: null,
            nomeArquivo: '',
            fileAssinado: null,
            nomeArquivoAssinado: '',
            pdfGerado: false,
            pdfProntoParaAssinatura: false,
            mostrarModalConfirmacao: false,
            arquivoPendente: null,
            carregandoUpload: false,
            previewUrl: null,
            pdfUrl: null,
            carregandoPdf: false,
            verificandoPdf: false,
            plantaAssinadaUrl: null,
            carregandoPlantaAssinada: false,
            pdfExistenteViaVerificacao: false,
            imagemPlantaFaladaUrl: null,
            logoSuape: 'data:image/png;base64,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',
            semPlantaFaladaAnexada: false
        }
    },
    computed: {
        temArquivo() {
            return this.file && this.nomeArquivo !== ''
        },
        desabilitarBtnEnviarAssinado() {
            return !this.fileAssinado || !this.editavel || this.carregandoUpload
        },
        etapaAtiva() {
            if (!this.temArquivo) {
                return 1
            }
            if (this.pdfGerado) {
                return 3
            }
            return 2
        },
        ehImagem() {
            if (!this.arquivoPendente) return false
            const extensao = this.arquivoPendente.name.split('.').pop().toLowerCase()
            return ['jpg', 'jpeg', 'png'].includes(extensao)
        },
        ehPdf() {
            if (!this.arquivoPendente) return false
            const extensao = this.arquivoPendente.name.split('.').pop().toLowerCase()
            return extensao === 'pdf'
        },
        dadosPlantaFalada() {
            return {
                numeroContrato: this.contrato?.codContrato || '',
                contratada: this.contrato?.fornecedor ? (`${this.contrato.fornecedor.cnpj} - ${this.contrato.fornecedor.nome}`) : '',
                objeto: this.contrato?.objeto || '',
                medicao: this.boletimMedicao?.numero,
                periodo: this.obterPeriodoBoletim(),
                logoFornecedorUrl: this.fornecedorLogoUrl
            }
        },
        documentoPlantaFaladaAssinada() {
            return (this.boletimMedicao?.anexos || []).find(a => a.tipoAnexoBoletimMedicao === tiposAnexoEnum.PlantaFaladaAssinadaPeloFornecedor) || null
        },
        nomeArquivoAssinadoExistente() {
            return this.documentoPlantaFaladaAssinada
                ? (this.documentoPlantaFaladaAssinada.nomeDocumento || this.documentoPlantaFaladaAssinada.nomeArquivo || this.documentoPlantaFaladaAssinada.nome || 'Arquivo já enviado')
                : null
        },
        deveManterModoUpload() {
            return this.$store.getters.isFornecedor
                && this.boletimMedicao?.status === statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFornecedor
        },
        podeGerarPdfParaAssinatura() {
            return (this.$store.getters.isFornecedor
                && this.boletimMedicao?.status === statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFornecedor)
                || (this.$store.getters.isFornecedor
                    && this.boletimMedicao?.status === statusBoletimMedicaoEnum.DevolvidoParaReassinarFornecedor
                    && this.boletimMedicao?.plantaFaladaEditavel)
        },
        deveForcarVisualizacaoImagemStatusAssinaturaSuape() {
            return false
        },
        deveExibirImagemComCabecalho() {
            return this.pdfExistenteViaVerificacao && !this.pdfProntoParaAssinatura
        },
        textoBotaoFluxoAssinatura() {
            return 'Gerar PDF para Assinatura'
        },
        nomeArquivoPreviewPlantaFalada() {
            const nomeBase = this.nomeArquivoAssinadoExistente
                || this.nomeArquivo
                || this.montarNomeArquivoPlantaFalada()

            return this.garantirExtensaoPdf(nomeBase)
        },
        srcVisualizacaoPdf() {
            return this.montarUrlVisualizacaoPdf(this.pdfUrl)
        },
        srcVisualizacaoPlantaAssinada() {
            return this.montarUrlVisualizacaoPdf(this.plantaAssinadaUrl)
        }
    },
    methods: {
        async acaoBotaoFluxoAssinatura() {
            if (this.semPlantaFaladaAnexada) {
                await this.gerarPdfSemPlantaFalada()
                return
            }

            await this.gerarPdfAssinatura()
        },
        formatarDataPeriodo(data) {
            if (!data) return ''
            const dataFormatada = this.$moment(data)
            if (!dataFormatada.isValid() || dataFormatada.year() <= 1) return ''
            return dataFormatada.format('DD/MM/YYYY')
        },
        montarUrlVisualizacaoPdf(url) {
            if (!url) return null
            const [urlSemFragmento] = url.split('#')
            return `${urlSemFragmento}#toolbar=0`
        },
        garantirExtensaoPdf(nomeArquivo) {
            const nome = (nomeArquivo || '').toString().trim()
            if (!nome) return ''
            return nome.toLowerCase().endsWith('.pdf')
                ? nome
                : `${nome}.pdf`
        },
        obterPeriodoBoletim() {
            const inicio = this.formatarDataPeriodo(this.boletimMedicao?.dataInicio)
            const fim = this.formatarDataPeriodo(this.boletimMedicao?.dataFim)

            if (inicio && fim) return `${inicio} a ${fim}`
            if (inicio) return inicio
            if (fim) return fim

            return this.boletimMedicao?.competencia
                ? `${this.$moment(this.boletimMedicao.competencia).startOf('month').format('DD/MM/YYYY')} a ${this.$moment(this.boletimMedicao.competencia).endOf('month').format('DD/MM/YYYY')}`
                : ''
        },
        handleFileChange(file) {
            if (!this.editavel) return
            if (file) {
                this.arquivoPendente = file
                this.gerarPreview(file)
                this.mostrarModalConfirmacao = true
            } else {
                this.arquivoPendente = null
                this.limparPreview()
            }
        },
        gerarPreview(file) {
            if (file) {
                const extensao = file.name.split('.').pop().toLowerCase()
                if (['jpg', 'jpeg', 'png'].includes(extensao)) {
                    this.previewUrl = URL.createObjectURL(file)
                } else if (extensao === 'pdf') {
                    this.previewUrl = URL.createObjectURL(file) + '#toolbar=0'
                } else {
                    this.previewUrl = null
                }
            }
        },
        limparPreview() {
            if (this.previewUrl) {
                URL.revokeObjectURL(this.previewUrl)
                this.previewUrl = null
            }
        },
        async verificarPlantaFaladaAssinada() {
            if (this.$store.getters.isFornecedor
                && this.boletimMedicao?.status === statusBoletimMedicaoEnum.DevolvidoParaReassinarFornecedor
                && this.boletimMedicao?.plantaFaladaEditavel) {
                this.pdfGerado = true
                this.pdfProntoParaAssinatura = false
                this.file = { name: 'Planta Falada.pdf' }
                this.nomeArquivo = 'Planta Falada.pdf'
                return
            }

            this.carregandoPlantaAssinada = true
            this.$store.dispatch('addRequest')

            try {
                const contratoId = this.boletimMedicao?.contratoId || this.contrato?.contratoId || this.$route.params.codContrato
                const boletimMedicaoId = this.boletimMedicao?.boletimMedicaoId || this.$route.params.idBoletimMedicao

                const blob = await BoletimMedicaoServicos.obterPlantaFaladaAssinada(contratoId, boletimMedicaoId)

                if (blob && blob.type !== 'application/json') {
                    if (this.deveForcarVisualizacaoImagemStatusAssinaturaSuape) {
                        this.plantaAssinadaUrl = null
                        this.pdfGerado = false
                        this.pdfProntoParaAssinatura = false
                        this.pdfExistenteViaVerificacao = true
                        this.file = { name: 'Planta Falada.pdf' }
                        this.nomeArquivo = 'Planta Falada.pdf'
                        await this.obterImagemPlantaFalada()
                        return
                    }

                    if (this.deveManterModoUpload) {
                        if (this.documentoPlantaFaladaAssinada) {
                            await this.inicializarModoUploadComDocumentoExistente()
                        } else {
                            await this.verificarPdfExistente()
                        }
                        return
                    }

                    if (this.$store.getters.isFornecedor
                        && this.boletimMedicao?.status === statusBoletimMedicaoEnum.DevolvidoParaCorrecaoFornecedor) {
                        await this.verificarPdfExistente()
                        return
                    }

                    this.plantaAssinadaUrl = URL.createObjectURL(blob)
                    return
                }
            } catch (error) {
                if (!(error.response && error.response.status === 404)) {
                    console.error('Erro ao obter planta falada assinada:', error)
                }
            } finally {
                this.carregandoPlantaAssinada = false
                this.$store.dispatch('removeRequest')
            }

            await this.verificarPdfExistente()
        },
        async inicializarModoUploadComDocumentoExistente() {
            this.plantaAssinadaUrl = null
            this.pdfGerado = true
            this.pdfProntoParaAssinatura = false
            this.pdfExistenteViaVerificacao = true
            this.file = { name: 'Planta Falada.pdf' }
            this.nomeArquivo = 'Planta Falada.pdf'

            await this.obterImagemPlantaFalada()

            if (!this.pdfUrl) {
                await this.carregarPdf(false)
            }
        },
        async verificarPdfExistente() {
            this.verificandoPdf = true
            this.$store.dispatch('addRequest')

            try {
                const contratoId = this.boletimMedicao?.contratoId || this.contrato?.contratoId || this.$route.params.codContrato
                const boletimMedicaoId = this.boletimMedicao?.boletimMedicaoId || this.$route.params.idBoletimMedicao

                const dto = {}
                if (this.fornecedorLogoUrl) {
                    dto.logoFornecedor = this.fornecedorLogoUrl
                }
                if (this.logoSuape) {
                    dto.logoSuape = this.logoSuape
                }

                const blob = await BoletimMedicaoServicos.exportarPlantaFalada(contratoId, boletimMedicaoId, dto)

                if (blob && blob.type !== 'application/json') {
                    this.pdfUrl = URL.createObjectURL(blob)
                    this.file = { name: 'Planta Falada.pdf' }
                    this.nomeArquivo = 'Planta Falada.pdf'
                    this.pdfExistenteViaVerificacao = true
                    await this.obterImagemPlantaFalada()
                }
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    if (this.deveManterModoUpload) {
                        // Na etapa de coleta de assinatura sem imagem: não exibe upload, exibe aviso
                        this.semPlantaFaladaAnexada = true
                        this.file = { name: 'Planta Falada.pdf' }
                        this.nomeArquivo = 'Planta Falada.pdf'
                    } else {
                        this.file = null
                        this.nomeArquivo = ''
                    }
                } else {
                    console.error('Erro ao verificar PDF:', error)
                }
            } finally {
                this.verificandoPdf = false
                this.$store.dispatch('removeRequest')
            }
        },
        async obterImagemPlantaFalada() {
            console.log('obterImagemPlantaFalada')
            try {
                const contratoId = this.boletimMedicao?.contratoId || this.contrato?.contratoId || this.$route.params.codContrato
                const boletimMedicaoId = this.boletimMedicao?.boletimMedicaoId || this.$route.params.idBoletimMedicao

                const blob = await BoletimMedicaoServicos.obterImagemPlantaFalada(contratoId, boletimMedicaoId)

                if (blob && blob.type && blob.type.startsWith('image/')) {
                    if (this.imagemPlantaFaladaUrl) {
                        URL.revokeObjectURL(this.imagemPlantaFaladaUrl)
                    }
                    this.imagemPlantaFaladaUrl = URL.createObjectURL(blob)
                }
            } catch (error) {
                if (!(error.response && error.response.status === 404)) {
                    console.error('Erro ao obter imagem da planta falada:', error)
                }
            }
        },
        async carregarPdf(forcarRegeneracao = false) {
            if (this.pdfUrl && !forcarRegeneracao) {
                return true
            }
            this.carregandoPdf = true
            this.$store.dispatch('addRequest')

            try {
                const contratoId = this.boletimMedicao?.contratoId || this.contrato?.contratoId || this.$route.params.codContrato
                const boletimMedicaoId = this.boletimMedicao?.boletimMedicaoId || this.$route.params.idBoletimMedicao

                const dto = {}
                if (this.fornecedorLogoUrl) {
                    dto.logoFornecedor = this.fornecedorLogoUrl
                }
                if (this.logoSuape) {
                    dto.logoSuape = this.logoSuape
                }

                const blob = await BoletimMedicaoServicos.exportarPlantaFalada(contratoId, boletimMedicaoId, dto)

                if (blob && blob.type !== 'application/json') {
                    if (this.pdfUrl) {
                        URL.revokeObjectURL(this.pdfUrl)
                    }
                    this.pdfUrl = URL.createObjectURL(blob)
                    return true
                } else {
                    this.$toast.error('Erro ao carregar o PDF', 'Erro', this.$toastConfig.error)
                    return false
                }
            } catch (error) {
                this.$toast.error('Erro ao carregar o PDF', 'Erro', this.$toastConfig.error)
                return false
            } finally {
                this.carregandoPdf = false
                this.$store.dispatch('removeRequest')
            }
        },
        async confirmarUpload() {
            if (!this.editavel) return
            if (!this.arquivoPendente) {
                return
            }

            this.carregandoUpload = true
            this.$store.dispatch('addRequest')

            try {
                const base64 = await this.toBase64(this.arquivoPendente)
                const extensao = this.arquivoPendente.name.split('.').pop()

                const dto = {
                    ArquivoBase64: base64,
                    NomeArquivo: this.arquivoPendente.name,
                    ExtensaoArquivo: extensao
                }

                const contratoId = this.boletimMedicao?.contratoId || this.contrato?.contratoId || this.$route.params.codContrato
                const boletimMedicaoId = this.boletimMedicao?.boletimMedicaoId || this.$route.params.idBoletimMedicao

                const response = await BoletimMedicaoServicos.uploadPlantaFaladaArquivo(contratoId, boletimMedicaoId, dto)

                if (response && response.success) {
                    this.file = this.arquivoPendente
                    this.nomeArquivo = this.arquivoPendente.name
                    this.pdfProntoParaAssinatura = false
                    if (this.pdfUrl) {
                        URL.revokeObjectURL(this.pdfUrl)
                        this.pdfUrl = null
                    }
                    this.pdfExistenteViaVerificacao = true
                    await this.obterImagemPlantaFalada()
                    this.$toast.success(response.data?.mensagem || 'Arquivo enviado com sucesso!', 'Sucesso', this.$toastConfig.success)
                    this.$emit('file-selected', this.arquivoPendente)
                } else {
                    this.$toast.error('Erro ao enviar o arquivo', 'Erro', this.$toastConfig.error)
                    this.arquivoPendente = null
                    this.nomeArquivo = ''
                    this.file = null
                }
            } catch (error) {
                this.$toast.error('Erro ao enviar o arquivo', 'Erro', this.$toastConfig.error)
                this.arquivoPendente = null
                this.nomeArquivo = ''
                this.file = null
                if (this.$refs.fileInput) {
                    this.$refs.fileInput.$el.querySelector('input[type=file]').value = ''
                }
            } finally {
                this.carregandoUpload = false
                this.$store.dispatch('removeRequest')
                this.mostrarModalConfirmacao = false
            }
        },
        cancelarUpload() {
            this.arquivoPendente = null
            this.file = null
            this.limparPreview()
            if (this.$refs.fileInput) {
                this.$refs.fileInput.reset()
            }
        },
        toBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => {
                    let encoded = reader.result.toString().replace(/^data:(.*,)?/, '')
                    resolve(encoded)
                }
                reader.onerror = error => reject(error)
            })
        },
        async trocarImagem() {
            if (!this.editavel) return
            if (this.file) {
                this.$store.dispatch('addRequest')

                try {
                    const contratoId = this.boletimMedicao?.contratoId || this.contrato?.contratoId || this.$route.params.codContrato
                    const boletimMedicaoId = this.boletimMedicao?.boletimMedicaoId || this.$route.params.idBoletimMedicao

                    const response = await BoletimMedicaoServicos.deletarPlantaFaladaArquivo(contratoId, boletimMedicaoId)

                    if (response && (response.success || response.mensagem)) {
                        this.$toast.success(response.mensagem || 'Arquivo removido com sucesso!', 'Sucesso', this.$toastConfig.success)
                    } else {
                        this.$toast.error('Erro ao remover o arquivo', 'Erro', this.$toastConfig.error)
                    }
                } catch (error) {
                    this.$toast.error('Erro ao remover o arquivo', 'Erro', this.$toastConfig.error)
                } finally {
                    this.$store.dispatch('removeRequest')
                }
            }

            if (this.pdfUrl) {
                URL.revokeObjectURL(this.pdfUrl)
                this.pdfUrl = null
            }
            if (this.imagemPlantaFaladaUrl) {
                URL.revokeObjectURL(this.imagemPlantaFaladaUrl)
                this.imagemPlantaFaladaUrl = null
            }

            this.file = null
            this.arquivoPendente = null
            this.nomeArquivo = ''
            this.pdfGerado = false
            this.pdfProntoParaAssinatura = false
            this.pdfExistenteViaVerificacao = false
            this.semPlantaFaladaAnexada = false
            if (this.$refs.fileInput) {
                this.$refs.fileInput.reset()
            }
            this.$emit('trocar-imagem')
        },
        async gerarPdfAssinatura() {
            if (!this.podeGerarPdfParaAssinatura) return
            const sucesso = await this.carregarPdf(true)
            if (sucesso) {
                this.pdfProntoParaAssinatura = true
                this.$toast.success('PDF gerado com sucesso!', 'OK', this.$toastConfig.success)
            }
        },

        async gerarPdfSemPlantaFalada() {
            this.carregandoPdf = true
            this.$store.dispatch('addRequest')
            try {
                const contratoId = this.boletimMedicao?.contratoId || this.contrato?.contratoId || this.$route.params.codContrato
                const boletimMedicaoId = this.boletimMedicao?.boletimMedicaoId || this.$route.params.idBoletimMedicao

                const dto = { semImagem: true }
                if (this.fornecedorLogoUrl) {
                    dto.logoFornecedor = this.fornecedorLogoUrl
                }
                if (this.logoSuape) {
                    dto.logoSuape = this.logoSuape
                }

                const blob = await BoletimMedicaoServicos.exportarPlantaFalada(contratoId, boletimMedicaoId, dto)
                if (blob) {
                    if (this.pdfUrl) URL.revokeObjectURL(this.pdfUrl)
                    this.pdfUrl = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }))
                    this.pdfProntoParaAssinatura = true
                    this.$toast.success('PDF gerado com sucesso!', 'OK', this.$toastConfig.success)
                }
            } catch (error) {
                this.$toast.error('Erro ao gerar PDF', 'Erro', this.$toastConfig.error)
            } finally {
                this.carregandoPdf = false
                this.$store.dispatch('removeRequest')
            }
        },
        normalizarParteNomeArquivo(valor, fallback = '') {
            const texto = (valor || '').toString().trim()
            if (!texto) return fallback

            const semAcento = texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
            const limpo = semAcento
                .replace(/[\\/:*?"<>|]+/g, '_')
                .replace(/\s+/g, '_')
                .replace(/_+/g, '_')
                .replace(/^[_\.]+|[_\.]+$/g, '')

            return limpo || fallback
        },
        montarNomeArquivoPlantaFalada() {
            const nomeBm = this.normalizarParteNomeArquivo(
                this.boletimMedicao?.numero || this.boletimMedicao?.nome,
                'BM'
            )
            const numeroContrato = this.normalizarParteNomeArquivo(
                this.contrato?.codContrato || this.$route?.params?.codContrato,
                'Contrato'
            )

            return `PlantaFalada_${nomeBm}_${numeroContrato}.pdf`
        },
        baixarPdfAssinatura() {
            if (!this.pdfUrl) {
                this.$toast.warning('Gere o PDF antes de baixar.', 'Atenção', this.$toastConfig.warning)
                return
            }

            const link = document.createElement('a')
            link.href = this.pdfUrl
            link.download = this.montarNomeArquivoPlantaFalada()
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        },
        proximaEtapa() {
            if (!this.editavel) return
            this.pdfGerado = true
            this.$emit('proxima-etapa')
        },
        handleFileChangeAssinado(file) {
            if (!this.editavel) return
            this.fileAssinado = file || null
            this.nomeArquivoAssinado = file ? file.name : ''
        },
        limparArquivoAssinado() {
            this.fileAssinado = null
            this.nomeArquivoAssinado = ''
            if (this.$refs.fileInputAssinado && this.$refs.fileInputAssinado.$el) {
                const input = this.$refs.fileInputAssinado.$el.querySelector('input[type=file]')
                if (input) input.value = ''
            }
        },
        validarArquivoAssinadoSelecionado() {
            if (!this.fileAssinado) return false
            const nomeArquivo = (this.fileAssinado.name || '').toLowerCase()
            const extensaoValida = nomeArquivo.endsWith('.pdf')
            const tipoArquivo = this.fileAssinado.type
            const tipoValido = !tipoArquivo || tipoArquivo === 'application/pdf'

            if (!extensaoValida || !tipoValido) {
                this.$toast.error('Apenas arquivos em formato PDF são permitidos', 'Erro', this.$toastConfig.error)
                this.limparArquivoAssinado()
                return false
            }
            return true
        },
        async enviarArquivoAssinadoSelecionado() {
            if (!this.validarArquivoAssinadoSelecionado()) return
            await this.uploadArquivoAssinado(this.fileAssinado)
        },
        async uploadArquivoAssinado(file) {
            if (!this.editavel) return
            this.carregandoUpload = true
            this.$store.dispatch('addRequest')

            try {
                const dto = {
                    tipo: tiposAnexoEnum.PlantaFaladaAssinadaPeloFornecedor,
                    arquivo: file
                }

                const contratoId = this.boletimMedicao?.contratoId || this.contrato?.contratoId || this.$route.params.codContrato
                const boletimMedicaoId = this.boletimMedicao?.boletimMedicaoId || this.$route.params.idBoletimMedicao
                const documentoBoletimMedicaoId = this.documentoPlantaFaladaAssinada?.documentoBoletimMedicaoId

                const response = documentoBoletimMedicaoId
                    ? await BoletimMedicaoServicos.atualizarDocumentoBoletimMedicao(contratoId, boletimMedicaoId, documentoBoletimMedicaoId, dto)
                    : await BoletimMedicaoServicos.adicionarDocumentoBoletimMedicao(contratoId, boletimMedicaoId, dto)

                if (response && response.success) {
                    this.$toast.success('Arquivo assinado enviado com sucesso!', 'Sucesso', this.$toastConfig.success)

                    this.$emit('file-assinado-selected', file)
                    this.$emit('recarregarDadosBoletim')
                    this.limparArquivoAssinado()
                } else {
                    this.$toast.error('Erro ao enviar o arquivo assinado', 'Erro', this.$toastConfig.error)
                    this.limparArquivoAssinado()
                }
            } catch (error) {
                this.$toast.error('Erro ao enviar o arquivo assinado', 'Erro', this.$toastConfig.error)
                this.limparArquivoAssinado()
            } finally {
                this.carregandoUpload = false
                this.$store.dispatch('removeRequest')
            }
        },
        voltarEtapa() {
            this.pdfGerado = false
            this.$emit('voltar-etapa')
        },
        async substituirPlantaAssinada() {
            if (!this.editavel) return
            this.$store.dispatch('addRequest')

            try {
                const contratoId = this.boletimMedicao?.contratoId || this.contrato?.contratoId || this.$route.params.codContrato
                const boletimMedicaoId = this.boletimMedicao?.boletimMedicaoId || this.$route.params.idBoletimMedicao

                const respAssinada = await BoletimMedicaoServicos.deletarPlantaFaladaAssinada(contratoId, boletimMedicaoId)
                const respOriginal = await BoletimMedicaoServicos.deletarPlantaFaladaArquivo(contratoId, boletimMedicaoId)

                if ((respAssinada && (respAssinada.success || respAssinada.mensagem)) ||
                    (respOriginal && (respOriginal.success || respOriginal.mensagem))) {
                    this.$toast.success('Planta falada substituída com sucesso. Faça o upload de uma nova planta.', 'Sucesso', this.$toastConfig.success)
                } else {
                    this.$toast.error('Erro ao remover a planta falada.', 'Erro', this.$toastConfig.error)
                }
            } catch (error) {
                this.$toast.error('Erro ao remover a planta falada.', 'Erro', this.$toastConfig.error)
            } finally {
                this.$store.dispatch('removeRequest')
            }

            if (this.plantaAssinadaUrl) {
                URL.revokeObjectURL(this.plantaAssinadaUrl)
                this.plantaAssinadaUrl = null
            }
            if (this.pdfUrl) {
                URL.revokeObjectURL(this.pdfUrl)
                this.pdfUrl = null
            }
            if (this.imagemPlantaFaladaUrl) {
                URL.revokeObjectURL(this.imagemPlantaFaladaUrl)
                this.imagemPlantaFaladaUrl = null
            }

            this.file = null
            this.nomeArquivo = ''
            this.fileAssinado = null
            this.nomeArquivoAssinado = ''
            this.pdfGerado = false
            this.pdfProntoParaAssinatura = false
            this.pdfExistenteViaVerificacao = false
            this.semPlantaFaladaAnexada = false

            if (this.$refs.fileInput) {
                this.$refs.fileInput.$el.querySelector('input[type=file]').value = ''
            }
            if (this.$refs.fileInputAssinado) {
                this.$refs.fileInputAssinado.$el.querySelector('input[type=file]').value = ''
            }
        }
    },
    watch: {
        'boletimMedicao.boletimMedicaoId': {
            immediate: true,
            async handler(valor) {
                if (!valor) return

                this.verificarPlantaFaladaAssinada()
            }
        }
    },
    beforeDestroy() {
        this.limparPreview()
        if (this.pdfUrl) {
            URL.revokeObjectURL(this.pdfUrl)
        }
        if (this.plantaAssinadaUrl) {
            URL.revokeObjectURL(this.plantaAssinadaUrl)
        }
        if (this.imagemPlantaFaladaUrl) {
            URL.revokeObjectURL(this.imagemPlantaFaladaUrl)
        }
    }
}
</script>

<style scoped>
.upload-wrapper {
    width: 100%;
}

.steps-container {
    margin-bottom: 30px;
}

.step-item {
    display: flex;
    align-items: center;
    font-weight: 600;
    color: #6c757d;
    font-size: 0.9rem;
}

.step-item.active {
    color: #007bff;
}

.step-item.completed {
    color: #23A26D;
}

.step-dot {
    width: 12px;
    height: 12px;
    background-color: #dee2e6;
    border-radius: 50%;
    margin-right: 8px;
}

.step-item.active .step-dot {
    background-color: #007bff;
}

.step-icon-green {
    color: #23A26D;
    margin-right: 8px;
    font-size: 1.1rem;
}

.step-line {
    width: 60px;
    height: 2px;
    background-color: #dee2e6;
    margin: 0 15px;
}

.step-line.completed {
    background-color: #23A26D;
}

.upload-card {
    padding: 40px;
}

.upload-card-assinado {
    background-color: #fff;
    border-radius: 8px;
    padding: 24px;
}

.steps-container-upload {
    margin-bottom: 30px;
}

.step-item-upload {
    display: flex;
    align-items: center;
    font-weight: 600;
    color: #0F97C7;
    font-size: 0.9rem;
}

.step-item-upload.active {
    color: #23A26D;
}

.step-blue-upload {
    color: #23A26D;
}

.step-label-blue-upload {
    font-size: 0.9rem;
    font-weight: 600;
    color: #23A26D;
}

.step-label-grey-upload {
    font-size: 0.9rem;
    font-weight: 600;
    color: #0F97C7;
}

.step-dot-upload {
    width: 12px;
    height: 12px;
    background-color: #0F97C7;
    border-radius: 50%;
    margin-right: 8px;
}

.step-dot-blue-upload {
    width: 12px;
    height: 12px;
    background-color: #23A26D;
    border-radius: 50%;
    margin-right: 8px;
}

.step-line-upload {
    width: 60px;
    height: 2px;
    background-color: #dee2e6;
    margin: 0 15px;
}

.step-line-upload.completed {
    background-color: #007bff;
}

.opacity-50 {
    opacity: 0.5;
}

.fa-thin {
    font-weight: 20 !important;
    -webkit-text-stroke: 0.5px white;
}

.b-form-file .custom-file-label::after {
    display: none;
}


.pdf-viewer-container {
    position: relative;
    min-height: 400px;
}

.etapa-geracao-pdf-container {
    position: relative;
    min-height: 400px;
}

.loading-overlay {
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 20;
}

.spinner-container {
    text-align: center;
}

.pdf-viewer {
    background-color: #fff;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 0;
    min-height: 400px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    position: relative;
}

.pdf-file-name {
    margin: 8px 8px 0;
    font-size: 14px;
    font-weight: 600;
    color: #2d3439;
    word-break: break-all;
}

.pdf-iframe {
    display: block;
    width: 100%;
    height: 800px;
    border: none;
    border-radius: 4px;
}

.botoes-acoes {
    position: absolute;
    bottom: 20px;
    left: 20px;
    display: flex;
    gap: 10px;
}

.botoes-acoes-container {
    margin-top: 20px;
    display: flex;
    gap: 10px;
}

.btn-acao {
    white-space: nowrap;
}

.btn-custom-azul {
    background-color: #2E60AD !important;
    border-color: #2E60AD !important;
    color: #fff !important;
}

.btn-custom-azul:hover {
    filter: brightness(0.9);
    color: #fff !important;
}

.btn-green-custom {
    background-color: #23A26D !important;
    border-color: #23A26D !important;
    color: #fff !important;
}

.btn-green-custom:hover {
    filter: brightness(0.9);
}

.btn-green-custom:disabled {
    background-color: #23A26D;
    border-color: #23A26D;
    opacity: 0.65;
}

.btn-voltar-custom {
    background-color: #2F5597 !important;
    border-color: #2F5597 !important;
    color: #fff !important;
}

.btn-voltar-custom:hover {
    filter: brightness(0.9);
}

.alert-success-custom {
    background-color: #D3ECE2;
    border-radius: 8px;
    padding: 12px 24px;
    max-width: fit-content;
    margin: 0 auto;
}

.text-instruction {
    color: #262A2E;
}

.font-weight-500 {
    font-weight: 500;
}

.anexar-assinado-container {
    position: relative;
    min-height: 400px;
}

.preview-container {
    margin-top: 20px;
    text-align: center;
    max-height: 500px;
    overflow: auto;
}

.preview-imagem {
    max-width: 100%;
    max-height: 500px;
    border: 1px solid #dee2e6;
    border-radius: 4px;
}

.preview-pdf {
    width: 100%;
    height: 500px;
    border: 1px solid #dee2e6;
    border-radius: 4px;
}

/* Planta Falada - Cabeçalho e Tabela */
.planta-falada-container {
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 20px;
}

.pf-header-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    margin-bottom: 5px;
    min-height: 80px;
}

.pf-logo-area {
    width: 20%;
    display: flex;
    align-items: center;
}

.pf-logo-left {
    justify-content: flex-start;
}

.pf-logo-right {
    justify-content: flex-end;
}

.pf-logo-img {
    max-width: 100%;
    max-height: 100px;
    object-fit: contain;
}

.pf-title-center {
    flex-grow: 1;
    text-align: center;
    font-weight: 600;
    font-size: 1.2rem;
    text-transform: uppercase;
}

.pf-box-placeholder {
    border: 1px solid #000;
    padding: 5px;
    font-weight: 500;
    text-align: center;
    font-size: 0.8rem;
    width: 100%;
}

.pf-data-table {
    border: 1px solid #000;
    display: flex;
    flex-direction: column;
}

.pf-table-row {
    display: flex;
    border-bottom: 1px solid #000;
}

.pf-table-row:last-child {
    border-bottom: none;
}

.pf-cell {
    padding: 4px 8px;
    display: flex;
    align-items: center;
    font-size: 0.85rem;
}

.pf-left-col {
    width: 60%;
    border-right: 1px solid #000;
}

.pf-right-col {
    width: 40%;
}

.pf-full-col {
    width: 100%;
}

.pf-label {
    font-weight: 600;
    text-transform: uppercase;
    margin-right: 5px;
    white-space: nowrap;
}

.pf-value {
    font-weight: 400;
    flex-grow: 1;
}

.pf-object-text {
    white-space: normal;
    line-height: 1.2;
}

/* Placeholder da imagem da planta */
.pf-imagem-placeholder {
    margin-top: 15px;
    border: 2px dashed #dee2e6;
    border-radius: 4px;
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f8f9fa;
}

.pf-imagem-area {
    text-align: center;
    opacity: 0.6;
}

.pf-imagem-container {
    margin-top: 15px;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    text-align: center;
    background-color: #fff;
}

.pf-imagem {
    width: 100%;
    height: auto;
    display: block;
    object-fit: contain;
    border-radius: 4px;
}

.sem-planta-falada-notice {
    display: flex;
    align-items: center;
    background-color: #e8f4fd;
    border: 1px solid #bee5eb;
    border-radius: 6px;
    padding: 20px 24px;
    margin-bottom: 20px;
    font-size: 1rem;
    color: #0c5460;
}
</style>
